module.exports = __webpack_public_path__ + "img/pro-5.086e3968.png";